import { useState } from "react"
import { NavLink } from "react-router-dom"

/**
 * Renders a responsive grid of module cards for quick navigation.
 *
 * Each item in the `modules` array:
 *   { id, label, description, icon, color, path, available }
 *
 * Items with available=false are hidden.
 */
const ModuleNavigator = ({ modules = [], title = null }) => {
    const [hovered, setHovered] = useState(null)

    const visible = modules.filter(m => m.available !== false)
    if (visible.length === 0) return null

    return (
        <div className="mb-4">
            {title && (
                <h6 className="text-muted text-uppercase fw-semibold mb-3" style={{ letterSpacing: "0.08em", fontSize: "0.75rem" }}>
                    <i className="fa-solid fa-grip me-2" />
                    {title}
                </h6>
            )}

            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-xl-6 g-3">
                {visible.map(mod => (
                    <div className="col" key={mod.id}>
                        <NavLink to={mod.path} className="text-decoration-none">
                            <div
                                className="card bg-dark text-white h-100"
                                style={{
                                    borderTop: `3px solid ${mod.color}`,
                                    borderLeft: "1px solid rgba(255,255,255,0.08)",
                                    borderRight: "1px solid rgba(255,255,255,0.08)",
                                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                                    transform: hovered === mod.id ? "translateY(-5px)" : "none",
                                    boxShadow: hovered === mod.id
                                        ? `0 12px 28px rgba(0,0,0,0.5), 0 0 0 1px ${mod.color}44`
                                        : "0 2px 8px rgba(0,0,0,0.3)",
                                    transition: "transform 0.18s ease, box-shadow 0.18s ease",
                                    cursor: "pointer",
                                }}
                                onMouseEnter={() => setHovered(mod.id)}
                                onMouseLeave={() => setHovered(null)}
                            >
                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center py-4 gap-2">
                                    <span style={{ color: mod.color, fontSize: "1.9rem", lineHeight: 1 }}>
                                        <i className={mod.icon} />
                                    </span>
                                    <span className="fw-semibold" style={{ fontSize: "0.85rem" }}>
                                        {mod.label}
                                    </span>
                                    {mod.description && (
                                        <span className="text-muted" style={{ fontSize: "0.72rem", lineHeight: 1.3 }}>
                                            {mod.description}
                                        </span>
                                    )}
                                </div>

                                <div
                                    className="card-footer d-flex justify-content-end py-1 px-3"
                                    style={{ borderTop: "1px solid rgba(255,255,255,0.06)", background: "transparent" }}
                                >
                                    <small style={{ color: mod.color, opacity: hovered === mod.id ? 1 : 0.4, transition: "opacity 0.18s" }}>
                                        <i className="fa-solid fa-arrow-right fa-xs" />
                                    </small>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ModuleNavigator
